(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-customer-preferences.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-customer-preferences.js');
"use strict";


const {
  useState,
  useEffect,
  useRef
} = React;
const {
  getCustomersPreferencesAsync
} = svs.ticketsOrderHome.services;
const useCustomerPreferences = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    const fetchCustomerInfo = async () => {
      try {
        const {
          playerPreferences,
          error
        } = await getCustomersPreferencesAsync();
        if (mounted.current) {
          setData(playerPreferences);
          setError(error);
        }
      } catch (err) {
        mounted.current && setError(err);
      } finally {
        mounted.current && setLoading(false);
      }
    };
    fetchCustomerInfo();
    return () => {
      mounted.current = false;
    };
  }, []);
  return {
    data,
    error,
    loading
  };
};
setGlobal('svs.ticketsOrderHome.hooks.useCustomerPreferences', useCustomerPreferences);

 })(window);